/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Backup_Enable_Auto_SaveInputs */

const en_options_backup_enable_auto_save = /** @type {(inputs: Options_Backup_Enable_Auto_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enable Automatic Save`)
};

const fr_options_backup_enable_auto_save = /** @type {(inputs: Options_Backup_Enable_Auto_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activer l'enregistrement automatique`)
};

const de_options_backup_enable_auto_save = /** @type {(inputs: Options_Backup_Enable_Auto_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatisches Speichern aktivieren`)
};

const it_options_backup_enable_auto_save = /** @type {(inputs: Options_Backup_Enable_Auto_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abilita salvataggio automatico`)
};

const ru_options_backup_enable_auto_save = /** @type {(inputs: Options_Backup_Enable_Auto_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Включить автоматическое сохранение`)
};

const es_options_backup_enable_auto_save = /** @type {(inputs: Options_Backup_Enable_Auto_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Habilitar guardado automático`)
};

const zh_cn2_options_backup_enable_auto_save = /** @type {(inputs: Options_Backup_Enable_Auto_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`启用自动保存`)
};

const ja_options_backup_enable_auto_save = /** @type {(inputs: Options_Backup_Enable_Auto_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自動保存を有効にする`)
};

const hi_options_backup_enable_auto_save = /** @type {(inputs: Options_Backup_Enable_Auto_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्वचालित सेव सक्षम करें`)
};

const pt_pt2_options_backup_enable_auto_save = /** @type {(inputs: Options_Backup_Enable_Auto_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ativar salvamento automático`)
};

/**
* | output |
* | --- |
* | "Enable Automatic Save" |
*
* @param {Options_Backup_Enable_Auto_SaveInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_backup_enable_auto_save = /** @type {((inputs?: Options_Backup_Enable_Auto_SaveInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Backup_Enable_Auto_SaveInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_backup_enable_auto_save(inputs)
	if (locale === "de") return de_options_backup_enable_auto_save(inputs)
	if (locale === "it") return it_options_backup_enable_auto_save(inputs)
	if (locale === "ru") return ru_options_backup_enable_auto_save(inputs)
	if (locale === "es") return es_options_backup_enable_auto_save(inputs)
	if (locale === "zh-CN") return zh_cn2_options_backup_enable_auto_save(inputs)
	if (locale === "ja") return ja_options_backup_enable_auto_save(inputs)
	if (locale === "hi") return hi_options_backup_enable_auto_save(inputs)
	if (locale === "pt-PT") return pt_pt2_options_backup_enable_auto_save(inputs)
	return en_options_backup_enable_auto_save(inputs)
});